import React from 'react';
const ArticleHeader = () => {
  return <div className="border-b pb-4" data-id="element-39">
      <h1 className="text-3xl font-bold mb-3 leading-tight" data-id="element-40">
        From Marathon Runner to Barely Walking: How Susan Got Her Life Back at
        52
      </h1>
      <h2 className="text-xl text-gray-700 mb-4 font-serif italic leading-relaxed" data-id="element-41">
        After 15 marathons and 30 years of running, she thought knee surgery was
        her only option – until a chance encounter at a farmer's market revealed
        a 4,000-year-old secret
      </h2>
      <div className="flex items-center justify-start border-b py-3 text-base text-gray-600" data-id="element-42">
        <div className="flex items-center gap-6" data-id="element-43">
          <div className="flex items-center gap-2" data-id="element-44">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-45">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-46" />
            </svg>
            <span className="text-base" data-id="element-47">September 17, 2025</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-48">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-49">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-50" />
            </svg>
            <span className="text-base" data-id="element-51">8 min read</span>
          </div>
        </div>
      </div>
    </div>;
};
export default ArticleHeader;